import { BaseFilterListRequestModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListRequestModel";

export class DenominationListRequestEntity extends BaseFilterListRequestModel {
  carrier?: Array<string>;
  providerCode?: string;

  constructor(data?: { carrier?: Array<string>; providerCode?: string }) {
    super();
    this.carrier = data?.carrier;
    this.providerCode = data?.providerCode;
  }
}
